/* eslint-disable max-len */
import * as React from "react";

export const IndustryIcon = (props: Record<string, any>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 18 16"
        aria-hidden={true}
        role="img"
        {...props}
    >
        <path fill="none" stroke="#505050" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M14.847 3.861H2.55A2.05 2.05 0 0 0 .5 5.911v7.173a2.05 2.05 0 0 0 2.05 2.05h12.297a2.05 2.05 0 0 0 2.05-2.05V5.911a2.05 2.05 0 0 0-2.05-2.05ZM.5 7.96h7.119m2.159 0h7.12" />
        <path fill="none" stroke="#505050" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M11.773 3.861H5.624l.37-1.783a.986.986 0 0 1 1.011-.689h3.387a.986.986 0 0 1 1.011.69l.37 1.782ZM9.266 6.935H8.131a.512.512 0 0 0-.512.512v2.05c0 .283.23.512.512.512h1.135a.512.512 0 0 0 .512-.512v-2.05a.512.512 0 0 0-.512-.512Z" />
    </svg>
);
IndustryIcon.displayName = "IndustryIcon";
